import {
  Modal,
  Stack,
  Box,
  Typography,
  IconButton,
  FormControl,
  Autocomplete,
  TextField,
  Button,
} from "@mui/material";
import { useState, SyntheticEvent, useCallback, FormEvent } from "react";
import { useCreateSpecialtiesMutation } from "src/api/services/providersApi";
import { desktopSx } from "src/utils/styles/modalStyles";
import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "src/components/Buttons/LoadingButton";
import { Specialties } from "src/api/types";
import { specialties } from "src/constants/specialties";

interface Props {
  open: boolean;
  onClose: () => void;
  providerId: number;
  providerSpecialties: Specialties[];
}

const CreateProviderSpecialtiesModal = ({
  open,
  onClose,
  providerId,
  providerSpecialties,
}: Props) => {
  const [selectedSpecialties, setSelectedSpecialties] =
    useState<Specialties[]>(providerSpecialties);
  const [createLicenses, { isLoading }] = useCreateSpecialtiesMutation();

  const handleChange = (
    _event: SyntheticEvent<Element, Event>,
    value: Specialties[]
  ) => {
    setSelectedSpecialties(value);
  };

  const handleSubmit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      createLicenses({
        provider_id: providerId,
        body: {
          specialties: selectedSpecialties,
        },
      })
        .unwrap()
        .then(onClose);
    },
    [createLicenses, onClose, providerId, selectedSpecialties]
  );

  return (
    <Modal open={open}>
      <Stack
        sx={desktopSx}
        gap={2}
        component="form"
        maxWidth={400}
        onSubmit={handleSubmit}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" component="h5" fontWeight={700}>
            Add Specialties
          </Typography>
          <IconButton onClick={onClose} sx={{ p: 0 }}>
            <CloseIcon fontSize="medium" />
          </IconButton>
        </Box>

        <FormControl fullWidth>
          <Autocomplete
            onChange={handleChange}
            multiple
            value={selectedSpecialties}
            fullWidth
            disablePortal
            options={specialties}
            renderInput={(params) => (
              <TextField {...params} label="Specialties" />
            )}
          />
        </FormControl>

        <Stack direction="row" gap={2} sx={{ marginTop: "auto" }}>
          <Button fullWidth variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton fullWidth loading={isLoading} type="submit">
            Create
          </LoadingButton>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default CreateProviderSpecialtiesModal;
